import { PropsWithChildren, ReactNode } from 'react';

type ConditionProps = PropsWithChildren<{ when: boolean; otherwise?: ReactNode }>;

export function Condition({ children, when, otherwise }: ConditionProps) {
  if (when) {
    return <> {children} </>;
  }

  if (otherwise) {
    return <> {otherwise} </>;
  }

  return null;
}
